import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { useQuizAndQuestionbankStore } from '../../store/quiz.store'
import { Box, Button, CircularProgress, Dialog, FormControlLabel, IconButton, Radio, RadioGroup, Typography, useTheme } from '@mui/material'
import { Icons } from '../../utils/utilities'
import CustomChip from '../common/CustomChip'


const classTypes = [
    { label: "Online class", value: "class", description: "In this standard online mode, faculty host live sessions where students can join and engage through real-time chat and multimedia tools." },
    { label: "Hybrid class with learning content", showQuizExistsTag: true, value: "hybrid-class", description: "This mode offers a direct live stream of offline classes for students who wish to attend remotely. Additionally, it provides recorded videos, allowing students to learn from uploaded content at their own pace." },
]

const HybridClassStartOptionsDialog = observer( ( { open, setOpen, onQuizDialogOpen, onStart, room } ) => {

    const [startingClass, setStartingClass] = useState( false )
    const [classType, setClassType] = useState( 'class' )

    const { palette, border, layout } = useTheme()

    const QuizStore = useQuizAndQuestionbankStore()

    const quizExists = QuizStore.getClassQuizzes[room.time_table_id]?.length
    // const quiz = QuizStore.getClassQuizzes[room.time_table_id]?.at( 0 )

    const startClass = async () => {
        setStartingClass( true )
        await onStart( { meeting_type: classType } )
        setOpen( null )
        setStartingClass( false )
    }

    useEffect( () => {
        QuizStore.fetchClassAssociatedQuizInstances()
    }, [QuizStore] )

    return (
        <Dialog
            open={open}
            onClose={() => setOpen( null )}
            slotProps={{
                paper: {
                    sx: {
                        width: "calc(100% - 20px)",
                        maxWidth: "sm"
                    }
                }
            }}
        >
            <Box>

                <Box padding="10px 20px" borderBottom={border[1]} gap={layout.cardsGap} display="flex" alignItems="center" justifyContent="space-between">
                    <Typography gutterBottom variant="h1" fontWeight="600" component="h1" fontSize="16px">Select Class type</Typography>
                    <IconButton color='greyed' onClick={() => setOpen( null )} >{Icons.default.CloseIcon}</IconButton>
                </Box>

                <Box padding="20px">

                    <RadioGroup
                        aria-labelledby="quiz_inclusion_rule"
                        name="quiz_inclusion_rule"
                        value={classType}
                        onChange={event => setClassType( event.target.value )}
                        sx={{
                            margin: 0,
                            display: "grid",
                            gap: "10px",
                            gridTemplateColumns: "1fr"
                        }}
                    >
                        {classTypes.map( classType => (
                            <FormControlLabel sx={{ margin: 0, border: border[1], borderColor: classType === classType.value && palette.secondary.main, borderRadius: "5px", padding: "10px", gap: "10px", alignItems: "flex-start" }} key={classType.label} value={classType.value} control={<Radio color="secondary" />} label={
                                <Box flexGrow={1}>
                                    {classType.showQuizExistsTag && quizExists && <CustomChip variant='filled' startIcon={Icons.default.CheckIcon} value="Quiz Assigned" />}
                                    <Typography display="block" fontSize="14px" variant='subtitle2'>{classType.label}</Typography>
                                    <Typography fontSize="12px">{classType.description}</Typography>
                                </Box>
                            } />
                        ) )}
                    </RadioGroup>

                    {!quizExists && classType === "hybrid-class" && <Box borderRadius={layout.borderRadius} marginTop="20px" border={border[1]} padding="10px" bgcolor={palette.contentBg}>
                        <Typography gutterBottom color='customThemeColor' variant='subtitle2' fontSize="13px" gap="10px" display="flex" alignItems="center" >{Icons.default.Warning} Quiz not assigned.</Typography>
                        <Typography fontSize="12px">The class with uploaded videos requires a quiz to be assigned to check students' understanding of the concepts described in the video. Please assign a quiz for this class before moving forward with the video uploads.</Typography>
                    </Box>}

                    <Box marginTop="20px" display="flex" gap={layout.cardsGap} justifyContent="flex-end" alignItems="center">
                        <Button color='greyed' onClick={() => setOpen( null )} size='small'>
                            Cancel
                        </Button>
                        {!quizExists && classType === "hybrid-class" && <Button variant='contained' onClick={onQuizDialogOpen} color='secondary' disableElevation size='small' endIcon={Icons.default.QuizIcon}>
                            Assign Quiz
                        </Button>}
                        <Button disabled={startingClass || ( !quizExists && classType === "hybrid-class" )} onClick={startClass} variant='contained' disableElevation size='small' startIcon={startingClass ? <CircularProgress size={14} /> : classType === "hybrid-class" ? Icons.default.HybridClasses : undefined} endIcon={classType === "hybrid-class" ? Icons.default.ArrowForward : Icons.default.Login}>
                            {classType === "hybrid-class" ? startingClass ? "Creating your class please wait..." : "Create Hybrid Class" : startingClass ? "Starting class..." : "Start Class"}
                        </Button>
                    </Box>

                </Box>
            </Box>
        </Dialog>
    )
}
)
export default HybridClassStartOptionsDialog


/*
 <Typography variant='subtitle2' component='h2' gutterBottom>
                        Choose how the attendance should be calculated.
                    </Typography>

                    <Box display="flex" alignItems="center" gap="10px" marginBottom="10px" padding="10px" bgcolor={palette.customThemeColor.light + 22} borderRadius={layout.borderRadius} border={`2px solid ${palette.customThemeColor.main}`}>
                        <Typography color='customThemeColor' display="flex" alignItems="center" >{Icons.default.Info}</Typography>
                        <Typography fontSize="0.8rem" color='customThemeColor' variant='subtitle2'>Please choose carefully as this configuration cannot be changed later.</Typography>
                    </Box>

                    <RadioGroup
                        aria-labelledby="quiz_inclusion_rule"
                        name="quiz_inclusion_rule"
                        value={quizRestrictionRule}
                        onChange={event => setQuizRestrictionRule( event.target.value )}
                        sx={{
                            margin: 0,
                            display: "grid",
                            gap: "10px",
                            gridTemplateColumns: "1fr"
                        }}
                    >
                        {quizInclusionInAttendanceOptions.map( quizInclusionInAttendanceOption => (
                            <FormControlLabel sx={{ margin: 0, border: border[1], borderColor: quizRestrictionRule === quizInclusionInAttendanceOption.value && palette.secondary.main, borderRadius: "5px", padding: "10px", gap: "10px", alignItems: "flex-start" }} key={quizInclusionInAttendanceOption.label} value={quizInclusionInAttendanceOption.value} control={<Radio color="secondary" />} label={
                                <Box flexGrow={1}>
                                    {quizInclusionInAttendanceOption.showQuizExistsTag && quizExists && <CustomChip variant='filled' startIcon={Icons.default.CheckIcon} value="Quiz Assigned" />}
                                    {quizInclusionInAttendanceOption.showQuizExistsTag && !quizExists && <CustomChip variant='filled' color="error" startIcon={Icons.default.QuizIcon} value="No Quiz" />}
                                    <Typography display="block" fontSize="14px" variant='subtitle2'>{quizInclusionInAttendanceOption.label}</Typography>
                                    <Typography fontSize="10px">{quizInclusionInAttendanceOption.description}</Typography>
                                </Box>
                            } />
                        ) )}
                    </RadioGroup>

                    

                    {!quizExists && quizRestrictionRule === "must_complete_quiz" && <Box display="flex" alignItems="center" gap="10px" marginTop="10px" padding="10px" bgcolor={palette.error.light + 22} borderRadius={layout.borderRadius} border={`2px solid ${palette.error.main}`}>
                        <Typography fontSize="0.8rem" color='error' variant='subtitle2'>Quiz is not assigned to this class! please assign a quiz before starting the hybrid-class.</Typography>
                    </Box>}

*/